import isStandardQuestion from './isStandardQuestion'

// De naam van één vraag in een rapportage: de kop boven de grafiek
// (`useQuestionHeading`) én de regel in 'Per vraag' van de widget 'Onderzoek'.
// Eén regel op één plek, zodat de maker in de lijst dezelfde naam ziet als de
// lezer boven de grafiek.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook

/**
 * @param {{Question?: string, Title?: string, Standard?: string|boolean, MSIId?: string}|null|undefined} field - QuestionnaireFields-document
 * @param {string} effectTitle - Naam van het gekoppelde effect ('' als die niet gevonden is); telt alleen bij een meetstandaardvraag
 * @returns {string} Bij een meetstandaardvraag de effectnaam (de vraagtekst is daar bij elk effect dezelfde), anders de vraagtekst; '' als er geen is
 */
const questionHeading = (field, effectTitle) => {
    if (!field) return ''
    return isStandardQuestion(field)
        ? effectTitle
        : (field.Question || field.Title || '').trim()
}

export default questionHeading
